export const siteSettings = {
  site_header: {
    menu: [
      {
        id: 1,
        label: "Studio",
        subMenu: [
          {
            id: 1,
            path: "/about",
            label: "About",
          },
          {
            id: 2,
            path: "/media",
            label: "Recognition",
          },
        ],
      },
      {
        id: 2,
        path: "/projects",
        label: "Projects",
        subMenu: [
          {
            id: 1,
            path: "/projects?tag=Residential",
            label: "Residential",
          },
          {
            id: 2,
            path: "/projects?tag=Commercial",
            label: "Commercial",
          },
          {
            id: 3,
            path: "/projects?tag=Hospitality",
            label: "Hospitality",
          },
        ],
      },
      {
        id: 4,
        label: "People",
        subMenu: [
          {
            id: 1,
            path: "/culture",
            label: "Culture",
          },
          // {
          //   id: 2,
          //   path: "/culture#culture",
          //   label: "Culture",
          // },
          {
            id: 3,
            path: "/careers",
            label: "Career",
          },
        ],
      },
    ],
    mobile_menu: [
      {
        id: 1,
        label: "Studio",
      },
      {
        id: 2,
        path: "/careers",
        label: "Career",
      },
      {
        id: 3,
        path: "/media",
        label: "Recognition",
      },
      {
        id: 4,
        path: "/blogs",
        label: "Blogs",
      },
      {
        id: 5,
        path: "/projects",
        label: "Projects",
        subMenu: [
          {
            id: 1,
            path: "/projects?tag=Residential",
            label: "Residential",
          },
          {
            id: 2,
            path: "/projects?tag=Commercial",
            label: "Commercial",
          },
          {
            id: 3,
            path: "/projects?tag=Hospitality",
            label: "Hospitality",
          },
        ],
      },
      {
        id: 6,
        path: "/culture",
        label: "Culture",
      },
    ],
  },
};
